/**
 * Created by lu on 2018/5/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        'class':'radio',
        'data-checked':nb.bind('checked'),
        tag:'label',
        $html:[{
            $name:'checkbox',
            tag:'input',
            type:'radio',
            name:nb.bind('name'),
            id:nb.bind('inputId'),
            value:nb.bind('value'),
            checked:nb.bind('checked')
        },{
            tag:'label',
            for:nb.bind('inputId'),
            'class':'radio-icon'
        }]
    },
    method:{
        init:function () {
            var self = this;
            this.$('checkbox').on('change',function (inEvent) {
                var checked = $(this).is(':checked');
                var model = self.getModel();
                model.set('checked',checked);
            });
        },
        onModelReady:function (inModel) {
            var inputId = 'input-id-'+nb.getSeq();
            inModel.set('inputId',inputId);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/Radio.js
// module id = 64
// module chunks = 0 2 3 8 9 15 22 23